// Public figures kept in one source; card volume restored at client request.
export const metricsList = [
  { id: "transactions", value: 50, prefix: "+", suffix: "M", label: "Transacciones procesadas / año" },
  { id: "availability", value: 99.9, suffix: "%", label: "Disponibilidad" },
  { id: "institutions", value: 100, prefix: "+", suffix: "", label: "Instituciones financieras" },
  { id: "countries", value: 5, suffix: "", label: "Países con presencia" },
  { id: "cards", value: 700, prefix: "+", suffix: "K", label: "Tarjetas procesadas" },
];

export const metricsById = Object.fromEntries(metricsList.map((metric) => [metric.id, metric]));
